// ThreadHeader Component
// Displays conversation avatar, title, participant info, and menu

import React from 'react';
import { Box, Avatar, Typography, IconButton } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import colors from '../../assets/theme/colors';

const ThreadHeader = ({ conversation, loading = false, onMenuClick }) => {
  const { t } = useTranslation('terms');
  const isGroup = conversation?.type === 'group';
  const title = loading
    ? conversation?.title || t('loading_messages')
    : conversation?.title || 'Conversation';

  const count = conversation?.participants?.length || 0;
  const subtitle = loading
    ? t('loading_messages')
    : t(count === 1 ? 'participants_one' : 'participants_other', { count });

  return (
    <Box
      sx={{
        px: 3,
        py: 2.5,
        borderBottom: 1,
        borderColor: colors.landing.borderLight,
        display: 'flex',
        alignItems: 'center',
        gap: 2.25,
        backgroundColor: 'rgba(248, 249, 255, 0.92)',
      }}
    >
      <Avatar
        sx={{
          bgcolor: colors.brand.ink,
          color: colors.landing.heroText,
          width: 56,
          height: 56,
          fontSize: '1.5rem',
        }}
      >
        {isGroup ? '👥' : '👤'}
      </Avatar>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            lineHeight: 1.15,
            color: 'text.primary',
            maxWidth: '100%',
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            mt: 0.5,
          }}
        >
          {subtitle}
        </Typography>
      </Box>
      <IconButton
        onClick={onMenuClick}
        aria-label="Thread menu"
        sx={{
          alignSelf: 'flex-start',
          mt: 0.25,
          color: 'text.secondary',
        }}
      >
        <MoreVert />
      </IconButton>
    </Box>
  );
};

export default ThreadHeader;
